var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bgblur_0_221_1874_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -10,
    y: -10,
    width: 68,
    height: 68
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5px)",
      height: "100%",
      width: "100%"
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 10,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2495 14H20.494C20.3145 14 20.2247 14 20.1455 14.0273C20.0754 14.0515 20.0116 14.0909 19.9587 14.1428C19.8988 14.2014 19.8587 14.2817 19.7784 14.4422L15.5784 22.8422C15.3867 23.2256 15.2909 23.4173 15.3139 23.5731C15.334 23.7091 15.4093 23.8309 15.522 23.9097C15.651 24 15.8653 24 16.294 24H22.4995L19.4995 34L31.6926 21.3553C32.104 20.9287 32.3097 20.7154 32.3217 20.5329C32.3321 20.3745 32.2667 20.2205 32.1454 20.118C32.0057 20 31.7094 20 31.1167 20H23.9995L26.2495 14Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_221_1874_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerIcon);
export default __webpack_public_path__ + "static/media/powerIcon.b235c325063cf9d7c1b2cefd1eea10f3.svg";
export { ForwardRef as ReactComponent };